export class RmaModel{
    public order_id: string = '';
    public rma_status: string = '';
    public product_name: string = '';
    public start_date: string = '';
    public end_date: string = '';
    public sku: string = '';
    public date_type: string = '';
    public invoice_number: string = '';
    public staff_username: string = ''
} 

export class RmaProductList{
    product_name: string = '';
    sku: string = '';
}


export class RmaListModel {
    public invoice_number: string = '';
    public order_id: string = '';
    public order_status: string = '';
    public date_issued: string = '';
    public date_updated: string = '';
    public date_approved: string = '';
    public staff_username; string = '';
    public products: Array<RmaProductList> = [];

}
